import React, { useState } from 'react';
import { Container, Col, Row, Input, Button, Progress } from "reactstrap"
import Evaporate from 'evaporate';
import sparkMD5 from 'spark-md5';
import sha256 from 'js-sha256';
import { WORKSHOP_BASE_URL } from "../../utils";
import QRCode from "react-qr-code";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

function MultipartTest() {
  const [fileInputFiles, setFileInputFiles] = useState('');
  const [uploadProgressPercentage, setUploadProgressPercentage] = useState(0);
  const [log, setLog] = useState('');

  const uploader = Evaporate.create({
    signerUrl: `${WORKSHOP_BASE_URL}/auth-upload`,
    aws_key: 'AKIAZFGJ6UVTR4TBLO6C',
    bucket: 'measure-user',
    cloudfront: true,
    computeContentMd5: true,
    cryptoMd5Method: (d) => btoa(sparkMD5.ArrayBuffer.hash(d, true)),
    cryptoHexEncodedHash256: sha256,
  });

  FingerprintJS.load()
    .then(fingerprintjs => {
      fingerprintjs.get()
        .then(result => {
          const fingerprint = result.visitorId;
          console.log(fingerprint);
        })
    });

  // const config = {
  //   signerUrl: 'http://localhost:6007/auth-upload',
  //   aws_key: 'AKIAZFGJ6UVTR4TBLO6C',
  //   bucket: 'measure-user'
  //   // cloudfront: true,
  //   // computeContentMd5: false
  //   // cryptoMd5Method: data => Crypto
  //   //   .createHash('md5')
  //   //   .update(data)
  //   //   .digest('base64');
  // };

  // const uploadFile = evaporate => {
  //   const file = new File([""], "file_object_to_upload");
  //
  //   const addConfig = {
  //     name: file.name,
  //     file: file,
  //     progress: progressValue => console.log('Progress', progressValue),
  //     complete: (_xhr, awsKey) => console.log('Complete!'),
  //   }
  //
  //   const overrides = {
  //     // bucket: AWS_BUCKET_2
  //   };
  //
  //   evaporate.add(addConfig, overrides)
  //     .then(
  //       awsObjectKey =>
  //         console.log('File successfully uploaded to:', awsObjectKey),
  //       reason =>
  //         console.log('File did not upload successfully:', reason)
  //     )
  // }
  //
  // Evaporate.create(config).then(uploadFile);

  // document.querySelector('#file-field').addEventListener('change', (evt) => {
  //   uploader.then((evaporate) => {
  //
  //     Array.from(evt.target.files).forEach((file) => {
  //       evaporate.add({
  //         file,
  //         name: file.name,
  //         progress: (progressValue) => console.log('Progress', progressValue),
  //         complete: (_xhr, awsKey) => console.log('Complete!', awsKey),
  //       }).then(
  //         (awsObjectKey) => console.log('File successfully uploaded to:', awsObjectKey),
  //         (reason) => console.log('File did not upload sucessfully:', reason)
  //       );
  //     });
  //
  //   });
  // });

  const handleStartUpload = (event) => {
    console.log('Starting upload...');
    setLog(prevLog => prevLog + 'Starting upload...\n');

    uploader.then((evaporate) => {

      Array.from(fileInputFiles).forEach((file) => {
        evaporate.add({
          file,
          name: 'foo/bar/' + file.name,
          progress: (progressValue) => {
            // setLog(prevLog => prevLog + 'Progress ' + progressValue + '\n');
            setUploadProgressPercentage(progressValue * 100);
          },
          complete: (_xhr, awsKey) => setLog(prevLog => prevLog + 'Complete! ' + awsKey + '\n'),
        }).then(
          (awsObjectKey) => setLog(prevLog => prevLog + 'File successfully uploaded to: ' + awsObjectKey + '\n'),
          (reason) => setLog(prevLog => prevLog + 'File did not upload sucessfully: ' + reason + '\n')
        );
      });

    });
  }

  const handleFileSelection = (event) => {
    console.log('got file');
    setLog(prevLog => prevLog +'File selected\n')
    setFileInputFiles(event.target.files);

    // setHasUploadError(false);
    //
    // if (event.target.files.length > 0) {
    //   const file = event.target.files[0];
    //
    //   // currently we only accept videos
    //   if (!file.type.toLowerCase().startsWith('video')) {
    //     setStatusMessage(`That file was the wrong type — the upload must be a video file captured on your
    //       device. Please tap the link above to select a video.`);
    //     resetVideo();
    //     setShowSpinner(false);
    //
    //     const c = uploadAttemptConfig[uploadAttempts]
    //     setShowInstructionsButton(c.showInstructionsLink);
    //     setShowTerminateButton(c.showTerminateLink);
    //     return;
    //   }
    //
    //   setNewVideoToValidate(true);
    //   setFileInputValue(event.target.value);
    //   setVideoFile(file);
    //   setVideoFilePath(URL.createObjectURL(file));
    // } else {
    //   resetVideo();
    // }
  };

  return (
    <Container fluid="sm">
      <Row>
        <Col>
          <div style={{textAlign: 'center', marginBottom: 30}}>
            <QRCode size={128} value="http://survey.alchemer.com/s3/6213171/Web-Retro-Test-Google-My-Activity-Staging" />
          </div>
          <p>This is a multipart upload test!</p>
          <p>
            <Input
              type="file"
              id="screenCaptureFile"
              // value={fileInputValue}
              onChange={handleFileSelection}
            />
          </p>
          <p>
            <Button
              color="primary"
              onClick={handleStartUpload}
            >
              Start upload
            </Button>
          </p>
        </Col>
      </Row>

      <Progress animated color="success" value={uploadProgressPercentage} max={100} />

      <Row>
        <Col>
          <div className="job-debugger">
            <pre>{log}</pre>
          </div>
        </Col>
      </Row>

    </Container>
  );
}

export default MultipartTest;
